import queryString from "query-string";

import { SCAN_LABEL } from "constants/actionTypes";
import { URLCreatorProps } from "actions/types";
import { serializeScanLabel } from "lib/serializers/scanLabel";

import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";

const urlCreator = ({
  changesSince,
  livestockSaleId,
  id,
  action,
}: URLCreatorProps = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/scan-labels/", id, action),
    query: {
      livestock_sale_id: livestockSaleId,
      changesSince,
    },
  });

export const ScanLabelAction = offlineActionCreator(
  SCAN_LABEL,
  serializeScanLabel,
  urlCreator,
  false,
);
